import { httpService } from '@dev.boon/brent';
import * as Sentry from '@sentry/browser';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

export interface Version {
    version?: string;
}

export const Version: React.FC = () => {
    const [showVersion, setShowVersion] = useState(false);
    const [version, setVersion] = useState('');
    const router = useRouter();

    const isProd = (): boolean => {
        if (typeof window === 'undefined') {
            return false;
        }
        return !(
            window.location.host.includes('testing') ||
            window.location.host.includes('staging') ||
            window.location.host.includes('localhost')
        );
    };

    useEffect(() => {
        const getVersion = async () => {
            try {
                const actualVersion = await httpService.get<Version>(
                    {},
                    {
                        url: '/version.json',
                    }
                );
                setVersion(actualVersion.data.version);
                setShowVersion(true);
            } catch (err) {
                Sentry.captureException(err);
            }
        };

        if (!isProd() || router.query?.v === '1') {
            getVersion();
        }
    }, []);

    return (
        showVersion && (
            <div className="bg-opacity-25 bg-boon-brown bottom-0 left-0 fixed rounded shadow">
                <span className="p-2 text-xs opacity-25 hover:opacity-100">Version: {version}</span>
            </div>
        )
    );
};
